import gql from 'graphql-tag';
import { type TerminateAgreementMutation } from 'src/app/shared/graphql/agreements/terminate-agreement-mutation.graphql.autogenerated';

export type TerminateAgreementMutationResult = TerminateAgreementMutation['terminateAgreement']['agreement'];

export const TerminateAgreementDocument = gql`
  mutation terminateAgreement($TerminateAgreementInput: TerminateAgreementInput!) {
    terminateAgreement(input: $TerminateAgreementInput) {
      agreement {
        id
        uuid
        status
        otherUser {
          id
          uuid
          accountType
        }
        currentUser {
          id
          uuid
        }
        job {
          id
          uuid
          jobKind {
            kind
          }
          status {
            clientStatusDescription
          }
        }
      }
    }
  }
`;
